import { useTranslation } from "next-i18next";

const PurchaseIntroInformation = () => {
  const { t } = useTranslation(["purchase"]);

  type IntroInfo = {
    title: string;
    content: string;
  };

  const introInfos: IntroInfo[] = [
    {
      title: t("purchase:add_vehicle_details"),
      content: t("purchase:provide_warranty_coverage_information"),
    },
    {
      title: t("purchase:enter_your_information"),
      content: t("purchase:fill_in_your_personal_details"),
    },
    {
      title: t("purchase:e_sign_documents"),
      content: t("purchase:e_sign_documents_for_convenience"),
    },
    {
      title: t("purchase:pay_with_card"),
      content: t("purchase:make_payment_using_preferred_card"),
    },
  ];

  return (
    <>
      {introInfos.map((info, index) => {
        return (
          <div key={info.title} className="m-12 hidden items-center lg:block">
            <div className="flex">
              <div className="mr-5 mt-[-9px] w-[10%] p-4">
                <div className="mr-5 inline-flex h-10 w-10 items-center justify-center rounded-full bg-white p-1">
                  <span className="h-5 w-5 rounded-full bg-primary-500 text-center font-medium text-white">
                    {index + 1}
                  </span>
                </div>
              </div>
              <div className="w-full p-4">
                <h3 className="mb-3">{info.title}</h3>
                <span className="text-md font-normal text-gray-500">
                  {info.content}
                </span>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default PurchaseIntroInformation;
